export default "__VITE_ASSET__D9ldm9hH__"